<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'register.account' | translate}}
  </div>
  <div class="form-container">
    <form [formGroup]="registerForm" class="form">
      <app-input 
        [label]="'labels.email' | translate"
        [placeholder]="'placeholders.email' | translate"
        [formControl]="emailControl"
        type="email"
      ></app-input>
      
      <app-input 
        [label]="'labels.password' | translate"
        [placeholder]="'placeholders.password' | translate"
        [formControl]="passwordControl"
        type="password"
      ></app-input>

      <app-input 
        [label]="'labels.confirm_password' | translate"
        [placeholder]="'placeholders.confirm_password' | translate"
        [formControl]="passwordVerificationControl"
        type="password"
      ></app-input>
    </form>

    <div class="actions-container">
      <app-button 
        [buttonLabel]="'buttons.cancel' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonDisabled]="false"
        (click)="cancel()">
      </app-button>
      
      <app-button
        [buttonLabel]="'buttons.register' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="isFormInvalid()"
        (click)="signUpWithEmail()">
      </app-button>
    </div>
    
  </div>
</div>